/**
 * Calculates days until a target date from today (UTC midnight).
 * Date-only strings (e.g. "2026-04-22") are parsed as UTC midnight per spec,
 * so we compare against UTC midnight to avoid timezone-offset inflation.
 */
const getDaysUntil = (targetDate: Date, now: Date | number = Date.now()): number => {
  const todayUTC = new Date(now);
  todayUTC.setUTCHours(0, 0, 0, 0);
  return Math.ceil((targetDate.getTime() - todayUTC.getTime()) / (1000 * 60 * 60 * 24));
};

export { getDaysUntil };
